import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../redux/store';
import { theme } from '../../styles/theme';

const BuylistIconContainer = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-left: 1.5rem;
`;

const BuylistBadge = styled.span`
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: ${theme.colors.accent};
  color: ${theme.colors.white};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
`;

// Styled icon for selling cards (reversed shopping cart)
const SellIcon = styled.span`
  
  
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;  // Match shopping cart size
  
  transform: scaleX(-1);  // This flips the cart horizontally
  
  &::before {
    content: '🛒';
    display: inline-block;
    vertical-align: middle;
  }
`;

const BuylistIcon: React.FC = () => {
  const { totalQuantity } = useSelector((state: RootState) => state.buylist);
  
  return (
    <BuylistIconContainer to="/buylist-cart" title="Selge kort">
      <SellIcon aria-hidden="true" />
      {totalQuantity > 0 && <BuylistBadge>{totalQuantity}</BuylistBadge>}
    </BuylistIconContainer>
  );
};

export default BuylistIcon;
